<template>
  <el-drawer
      title="备注信息"
      :visible.sync="show" :append-to-body="true" :wrapperClosable="false"
      direction="rtl">
    <div class="remark-box">
      <div class="list-box" v-if="dataList.length>0" >
        <el-timeline>
          <el-timeline-item v-for="item in dataList" :key="item.id" :timestamp="item.createDate" placement="top">
            <div class="content">
              <p>{{ item.remarkContent }}</p>
              <div style="display: flex;justify-content: flex-end;align-items: center;">{{ item.creatorName }} 提交于
                {{ item.createDate }}
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <el-empty v-if="dataList.length === 0" description="暂无备注信息"></el-empty>
      <div class="remark-input-box">
        <el-input v-model="remarkContent" placeholder="请输入备注内容" type="textarea" :rows="8"
                  resize="none"></el-input>
      </div>
      <div class="remark-btn-box">
        <el-button type="primary" size="small" @click="submitRemark">提交</el-button>
        <el-button type="default" size="small" @click="show = false">关闭</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
/**
 * 通用备注弹窗
 */
export default {
  name: 'remark-dialog',
  data () {
    return {
      dataList: [],
      show: false,
      bisId: '',
      remarkContent: ''
    }
  },
  props: {
    bisKey: {
      type: String,
      required: true
    },
  },
  methods: {
    async getRemarkList () {
      const data = await this.$api2.get('/erp/common/remark/list', {
        params: {
          bisKey: this.bisKey,
          bisId: this.bisId
        }
      })
      this.dataList = data
    },
    init (bisId) {
      this.bisId = bisId
      this.getRemarkList()
      this.show = true
    },
    async submitRemark () {
      if (this.remarkContent.trim() === '') {
        this.$message.error('请输入备注内容')
        return
      }
      const data = await this.$api2.post('/erp/common/remark/save', {
        bisKey: this.bisKey,
        bisId: this.bisId,
        remarkContent: this.remarkContent
      })
      this.remarkContent = ''
      this.getRemarkList()
    }
  }
}
</script>

<style lang="scss" scoped>
.remark-box {
  position: relative;

  .list-box {
    height: calc(100vh - 340px);
    overflow-x: hidden;
    overflow-y: auto;

    .content {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      border-radius: 4px;
      border: 1px solid #ebeef5;
      padding: 10px;
    }
  }

  .remark-input-box {
    margin: 20px;
  }

  .remark-btn-box {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    margin-right: 20px;
  }
}
</style>
